import { DatePicker, DatePickerProps } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import React from 'react';
import { IField } from '@hooks/useField';

export type DateFieldProps = Omit<DatePickerProps, "value" | "onChange"> & {
    field: IField,
    updateFieldStateOnChange?: boolean
    onValueChanged?: (value: any) => void
    onEnter?: React.KeyboardEventHandler<HTMLDivElement> | undefined
}

export function DateField ({
    field, 
    name,
    onValueChanged, 
    helperText, 
    updateFieldStateOnChange, 
    onEnter,
    onKeyDown,
    ...props
}: DateFieldProps) {
    const [_value, _setValue] = React.useState<MaterialUiPickersDate>(field.value);

    const handleChange = React.useCallback((date: MaterialUiPickersDate) => {
        if (date !== _value) {
            _setValue(date);
        }
    }, [_value]);

    const handleKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter" && onEnter !== undefined) {
            onEnter(e);
        }

        if (onKeyDown !== undefined) {
            onKeyDown(e);
        }
    }, [onEnter, onKeyDown]);

    //Reage à mudança do valor interno
    //Set o valor na ref
    //Chama o evento o change externo
    //Verifica se é para subir o estado automaticamente através da propriedade updateFieldStateOnChange
    React.useEffect(() => {
        field.setInputValue(_value);

        if (onValueChanged !== undefined) {
            onValueChanged(_value);
        }

        if (updateFieldStateOnChange === true && field.value !== _value) {
            field.setValue(_value);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_value, onValueChanged, updateFieldStateOnChange]);

    //Reage à mudança do valor externo
    //Atualiza o valor interno pelo valor externo
    React.useEffect(() => {
        if (field.value !== _value) {
            _setValue(field.value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.value]);

    React.useEffect(() => {
        if (field.transition === "reset") {
            _setValue(field.initialValueRef?.current);
            field.clearTransition();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field.transition]);

    return (
        <DatePicker 
            name={field !== undefined ? field.name : name}
            variant="inline"
            format="dd/MM/yyyy"
            autoOk
            {...props}    
            helperText={!!field.error ? field.error : helperText}
            error={!!field.error}
            value={_value || null}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            fullWidth
        />
    )
}